






import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import BaseTab from './baseTab'
import { ExStore } from 'vuex'

@Component
export default class DocumentTab extends mixins(BaseTab) {
  $store!: ExStore

  @Watch('$route')
  onUpdateRoute() {
    this.setIndexRoute()
  }

  created() {
    this.setIndexRoute()
  }

  setIndexRoute() {
    if (this.$route.name === 'DocumentTab') {
      this.$router.replace({ name: 'DocumentTabIndex' })
    }
  }
}
